import { Routes } from '@angular/router';

import { authGuard, noAuthGuard } from './core/guards';
import { NotFoundPage } from './core/layout/ui/not-found/not-found.page';
import { ROUTER_UTILS } from './core/utils/router.utils';

export const APP_ROUTES: Routes = [
  {
    path: ROUTER_UTILS.config.auth.root,
    loadChildren: () =>
      import('./states/auth/auth-routes').then((m) => m.authRoutes),
    canMatch: [noAuthGuard],
  },
  {
    path: ROUTER_UTILS.config.base.home,
    canMatch: [authGuard],
    redirectTo: ROUTER_UTILS.config.base.vehiclePark,
    pathMatch: 'full',
  },
  {
    path: ROUTER_UTILS.config.base.map,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/map/map-routes').then((m) => m.mapRoutes),
  },
  {
    path: ROUTER_UTILS.config.base.routesBook,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/routes-book/routes-book-routes').then(
        (m) => m.routesBookRoutes,
      ),
  },
  {
    path: ROUTER_UTILS.config.base.overview,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/overview/overview-routes').then((m) => m.overviewRoutes),
  },
  {
    path:
      ROUTER_UTILS.config.reports.basePath +
      '/' +
      ROUTER_UTILS.config.reports.canOverview,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/can-overview/can-overview-routes').then(
        (m) => m.canOverviewRoutes,
      ),
  },
  {
    path:
      ROUTER_UTILS.config.reports.basePath +
      '/' +
      ROUTER_UTILS.config.reports.drivingProgress,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/driving-progress/driving-progress-routes').then(
        (m) => m.drivingProgressRoutes,
      ),
  },
  {
    path:
      ROUTER_UTILS.config.reports.basePath +
      '/' +
      ROUTER_UTILS.config.reports.workingHours,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/working-hours/working-hours-routes').then(
        (m) => m.workingHoursRoutes,
      ),
  },
  {
    path:
      ROUTER_UTILS.config.reports.basePath +
      '/' +
      ROUTER_UTILS.config.reports.refueling,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/refueling/refueling-routes').then(
        (m) => m.refuelingRoutes,
      ),
  },
  {
    path:
      ROUTER_UTILS.config.reports.basePath +
      '/' +
      ROUTER_UTILS.config.reports.operatorsRegistry,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/operators-registry/operators-registry-routes').then(
        (m) => m.operatorsRegistryRoutes,
      ),
  },
  {
    path:
      ROUTER_UTILS.config.reports.basePath +
      '/' +
      ROUTER_UTILS.config.reports.aetr,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/aetr/aetr-routes').then((m) => m.aetrRoutes),
  },
  {
    path:
      ROUTER_UTILS.config.reports.basePath +
      '/' +
      ROUTER_UTILS.config.reports.temperatures,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/temperatures/temperatures-routes').then(
        (m) => m.temperaturesRoutes,
      ),
  },
  {
    path: ROUTER_UTILS.config.base.vehiclePark,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/vehicle-park/vehicle-park-routes').then(
        (m) => m.vehicleParkRoutes,
      ),
  },
  {
    path: ROUTER_UTILS.config.base.stations,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/stations/stations-routes').then((m) => m.stationsRoutes),
  },
  {
    // NFC deep link. authGuard preserves the query string via location.path(true),
    // so the tag's uid/ctr/cmac survive the sign-in round trip.
    path: ROUTER_UTILS.config.base.tag,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/tag/tag-routes').then((m) => m.tagRoutes),
  },
  {
    path: ROUTER_UTILS.config.base.vehicleDetail + '/:id',
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/vehicle-detail/vehicle-detail-routes').then(
        (m) => m.vehicleDetailRoutes,
      ),
  },
  {
    path: ROUTER_UTILS.config.reports.drivingStyle + '/:vehicleId/:eventId',
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/driving-style/driving-style-routes').then(
        (m) => m.drivingStyleRoutes,
      ),
  },
  {
    path: ROUTER_UTILS.config.reports.routeDetail + '/:vehicleId/:id',
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/route-detail/route-detail-routes').then(
        (m) => m.routeDetailRoutes,
      ),
  },
  {
    path: ROUTER_UTILS.config.base.event + '/:id',
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/event-map/event-map-routes').then((m) => m.eventRoutes),
  },
  {
    path: ROUTER_UTILS.config.base.activity + '/:id',
    canMatch: [authGuard],
    loadChildren: () =>
      import('./states/event-map/event-map-routes').then(
        (m) => m.activityRoutes,
      ),
  },
  {
    path: ROUTER_UTILS.config.errorResponse.notFound,
    component: NotFoundPage,
    data: {
      title: 'The page you were looking for could not be found',
    },
  },
  {
    path: '**',
    component: NotFoundPage,
  },
];
